@if (formGroupDiagnosis && diagnosisList && diagnosisList.length > 0) {
  <div class="full-width d-flex" [formGroup]="formGroupDiagnosis">
    <mat-form-field appearance="outline" class="input-code-width">
      <input matInput formControlName="code"
        [id]="'intDiagnosisCode' + uniqueId"
        [placeholder]="'medicalHistory.modify.diagnosis.inputFilter.code.label' | translate">
      </mat-form-field>
      <div class="dropdown-area-width">
        @if (generateDiagnosisLv1() && generateDiagnosisLv1().length > 0) {
          <mat-form-field appearance="outline" class="dropdown-list1-width">
            <mat-label>{{
              "medicalHistory.modify.diagnosis.dropdownLevel1.selectOrgan.label" | translate
            }}</mat-label>
            <mat-select formControlName="diagnosisLevel1" (selectionChange)="handleDiagnosisLevel1Change($event)">
              <mat-option>{{ 'medicalHistory.modify.diagnosis.dropdownLevel1.unselectOrgan.label' | translate }}</mat-option>
              @for (diagnosis of generateDiagnosisLv1(); track trackDiagnosis($index, diagnosis)) {
                <mat-option [value]="diagnosis.id">
                  <div>
                    @switch (currentLanguage) {
                      @case (Languages.de) {
                        <span>
                          {{diagnosis.designationDe }}
                        </span>
                      }
                      @case (Languages.it) {
                        <span>
                          {{diagnosis.designationIt }}
                        </span>
                      }
                      @case (Languages.fr) {
                        <span>
                          {{diagnosis.designationFr }}
                        </span>
                      }
                    }
                  </div>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <mat-form-field appearance="outline" class="dropdown-list2-width">
          <mat-label>{{
            "medicalHistory.modify.diagnosis.dropdownLevel2.selectFindings.label" | translate
          }}</mat-label>
          <mat-select formControlName="diagnosisLevel2">
            <mat-option>{{ 'medicalHistory.modify.diagnosis.dropdownLevel2.unselectFindings.label' | translate }}</mat-option>
            @for (diagnosis of generateDiagnosisLv2(); track trackDiagnosis($index, diagnosis)) {
              <mat-option [value]="diagnosis.id">
                <div>
                  @switch (currentLanguage) {
                    @case (Languages.de) {
                      <span>
                        {{diagnosis.designationDe }}
                      </span>
                    }
                    @case (Languages.it) {
                      <span>
                        {{diagnosis.designationIt }}
                      </span>
                    }
                    @case (Languages.fr) {
                      <span>
                        {{diagnosis.designationFr }}
                      </span>
                    }
                  }
                </div>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  }